import { render, staticRenderFns } from "./CardTarjaEnqueteTVZQRCODE.vue?vue&type=template&id=b431453c&scoped=true"
import script from "./CardTarjaEnqueteTVZQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTVZQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTVZQRCODE.vue?vue&type=style&index=0&id=b431453c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b431453c",
  null
  
)

export default component.exports